import React from "react";
import { Skeleton } from "components/skeleton";
import "./redeem-item.css";

/** Loading placeholder mirroring RedeemItem's row: date · amount · status badge. */
function SkeletonRedeemItem() {
  return (
    <div className="rdm-item">
      <div className="rdm-item__row">
        <span className="rdm-item__date">
          <Skeleton width={104} height={13} />
        </span>
        <Skeleton width={64} height={14} />
        <Skeleton width={82} height={22} borderRadius="99px" />
      </div>
    </div>
  );
}

export default SkeletonRedeemItem;
